import _ from 'lodash';
import {
  CHANGE_THEME,
  LOGOUT,
  PIN_SEND,
  PIN_VERIFY,
  SET_CURRENT_USER,
} from '../constants/actionTypes';

const initialState = {
  isAuthenticated: false,
  pinSend: null,
  pinVerify: null,
  user: {},
  isLogout: false,
  changeTheme: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_THEME: {
      return {
        ...state,
        changeTheme: action.payload,
      };
    }
    case PIN_VERIFY: {
      return {
        ...state,
        pinVerify: action.payload,
      };
    }
    case PIN_SEND: {
      return {
        ...state,
        pinSend: action.payload,
      };
    }
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !_.isEmpty(action.payload),
        user: action.payload,
      };
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        pinSend: null,
        pinVerify: null,
        user: {},
        isLogout: true,
        changeTheme: false,
      };
    default:
      return state;
  }
}
